import { render, staticRenderFns } from "./ProductTileWrapper.vue?vue&type=template&id=c0e9794a&"
import script from "./ProductTileWrapper.vue?vue&type=script&lang=js&"
export * from "./ProductTileWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports